const UNKNOWN_OWNER_LABEL = 'Не знайдено'

export const resolveOwnerLabel = (ownerValue, owners = []) => {
  if (!ownerValue) {
    return ''
  }

  const match = owners.find(({ value }) => value === ownerValue)

  return match?.label || UNKNOWN_OWNER_LABEL
}

export default resolveOwnerLabel
